export const scenarioPhases = {
  ASSEMBLY: 'ASSEMBLY',
  INTEGRATION: 'INTEGRATION',
  INSTALLATION: 'INSTALLATION',
  GLOBAL: 'GLOBAL'
}
